import { useState } from 'react';
import Notification from './Notification';
import { useSelector } from 'react-redux';
import { isAdminSelector } from 'store/selectors';
import { PublishedAppTab } from '../../components/tabs/publishedApp/PublishedAppTab';
import { NewAppTab } from '../../components/tabs/newApp/NewAppTab';

const GooglePage = ({ handleClose, chooseAction, page }) => {
  const isAdmin = useSelector(isAdminSelector);
  const [appIsPublished, setAppIsPublished] = useState(false);

  return (
    <>
      <div style={{ padding: `0 24px` }}>
        {
          <Notification
            isAdmin={isAdmin}
            clickAction={setAppIsPublished}
            appIsPublished={appIsPublished}
          />
        }
      </div>
      {!appIsPublished ? (
        <PublishedAppTab handleClose={handleClose} chooseAction={chooseAction} />
      ) : (
        <NewAppTab page={page} handleClose={handleClose} chooseAction={chooseAction} />
      )}
    </>
  );
};

export default GooglePage;
